( function($) {
	$( '.view-all-link' ).on( 'click', function() {
		if( $( this ).hasClass( 'open' ) ) {
			$( this ).removeClass( 'open' );
			$( this ).text( 'View More' );
			$( '.store-schedule-container' ).hide();
		}

		else {
			$( this ).addClass( 'open' );
			$( this ).text( 'View Less' );			
			$( '.store-schedule-container' ).show();
		}
	} );

	$( '.view-all-metal-shapes' ).on( 'click', function(e) {
		e.preventDefault();

		if( $( '.desktop-shape-list .shape-list-card.hidden-class-toggle' ).hasClass( 'uk-hidden' ) ) {
			$( this ).html( '<div class="show-more-text">See less metals</div><i class="fa-solid fa-chevron-up"></i>' );
			// $( this ).html( '<div class="show-more-text">See less metals</div><i class="fa-sharp fa-solid fa-chevron-up"></i>' );
			$( '.desktop-shape-list .shape-list-card.hidden-class-toggle' ).removeClass( 'uk-hidden' );
		}

		else {
			$( this ).html( '<div class="show-more-text">See all metals</div><i class="fa-solid fa-chevron-down"></i>' );
			// $( this ).html( '<div class="show-more-text">See all metals</div><i class="fa-sharp fa-solid fa-chevron-down"></i>' );
			$( '.desktop-shape-list .shape-list-card.hidden-class-toggle' ).addClass( 'uk-hidden' );
		}
	} );
} )( jQuery );
